import {
  enAdmin,
  enAssortment,
  enBanners,
  enCommon,
  enCredit,
  enCrt,
  enForms,
  enLaunches,
  enLogin,
  enMaterials,
  enOperations,
  enOrders,
  enReports,
  enSoxCompliance,
  enStores,
  enStructural,
  enUploads,
  enWelcome,
} from './en'
import {
  frAdmin,
  frAssortment,
  frBanners,
  frCommon,
  frCredit,
  frCrt,
  frForms,
  frLaunches,
  frLogin,
  frMaterials,
  frOperations,
  frOrders,
  frReports,
  frSoxCompliance,
  frStores,
  frStructural,
  frUploads,
  frWelcome,
} from './fr'

export const resources = {
  en: {
    admin: enAdmin,
    assortment: enAssortment,
    banners: enBanners,
    common: enCommon,
    forms: enForms,
    launches: enLaunches,
    login: enLogin,
    materials: enMaterials,
    operations: enOperations,
    orders: enOrders,
    reports: enReports,
    stores: enStores,
    welcome: enWelcome,
    structural: enStructural,
    uploads: enUploads,
    crt: enCrt,
    credit: enCredit,
    soxCompliance: enSoxCompliance,
  },
  fr: {
    admin: frAdmin,
    assortment: frAssortment,
    banners: frBanners,
    common: frCommon,
    forms: frForms,
    launches: frLaunches,
    login: frLogin,
    materials: frMaterials,
    operations: frOperations,
    orders: frOrders,
    reports: frReports,
    stores: frStores,
    welcome: frWelcome,
    structural: frStructural,
    uploads: frUploads,
    crt: frCrt,
    credit: frCredit,
    soxCompliance: frSoxCompliance,
  },
}
